import React,
{
  useEffect,
  useState
}
from "react";

import axios
from "axios";

const BASE_API =
  process.env.BASE_API_URL ||
  "https://scanmymenu-nm38.onrender.com/api";

export default function OwnerEditRestaurant() {

  const restaurantId =
    localStorage.getItem(
      "restaurantId"
    );

  const [
    restaurantName,
    setRestaurantName
  ] = useState("");

  const [
    restaurantAddress,
    setRestaurantAddress
  ] = useState("");

  const [
    phone,
    setPhone
  ] = useState("");

  const [
    email,
    setEmail
  ] = useState("");

  const [
    logo,
    setLogo
  ] = useState(null);

  const [
    qrUrl,
    setQrUrl
  ] = useState("");

  const [
    menuUrl,
    setMenuUrl
  ] = useState("");

  const [
    loading,
    setLoading
  ] = useState(false);

  /*
  LOAD RESTAURANT
  */

useEffect(() => {

  const fetchRestaurant = async () => {
    try {

      const res = await axios.get(
        `${BASE_API}/restaurants/${restaurantId}`
      );

      const data = res.data;

      setRestaurantName(
        data.restaurantName || ""
      );

      setRestaurantAddress(
        data.restaurantAddress || ""
      );

      setPhone(
        data.phone || ""
      );

      setEmail(
        data.email || ""
      );

      setQrUrl(
        data.qrUrl || ""
      );

      setMenuUrl(
        data.menuUrl || ""
      );

    }
    catch (error) {

      console.error(
        "Fetch restaurant error"
      );

    }
  };

  fetchRestaurant();

}, [restaurantId]);
  /*
  UPDATE RESTAURANT
  */

  const updateRestaurant =
    async (e) => {

    e.preventDefault();

    try {

      setLoading(true);

      const formData =
        new FormData();

      formData.append(
        "restaurantName",
        restaurantName
      );

      formData.append(
        "restaurantAddress",
        restaurantAddress
      );

      formData.append(
        "phone",
        phone
      );

      formData.append(
        "email",
        email
      );

      if (logo) {

        formData.append(
          "logo",
          logo
        );

      }

      const res =
        await axios.put(
          `${BASE_API}/restaurants/${restaurantId}/details`,
          formData
        );

      alert(
        "Restaurant updated successfully"
      );

      if (res.data.qrUrl) {

        setQrUrl(
          res.data.qrUrl
        );

      }

      if (res.data.menuUrl) {

        setMenuUrl(
          res.data.menuUrl
        );

      }

    }
    catch (error) {

      alert(
        "Update failed"
      );

    }
    finally {

      setLoading(false);

    }

  };

  /*
  COPY LINK
  */

  const copyLink =
    () => {

    navigator.clipboard.writeText(
      menuUrl
    );

    alert(
      "Menu link copied"
    );

  };

  /*
  DOWNLOAD QR
  */

  const downloadQR =
    () => {

    const link =
      document.createElement(
        "a"
      );

    link.href =
      qrUrl;

    link.download =
      "restaurant-qr.png";

    link.click();

  };

  return (

    <div style={styles.container}>

      <h2>
        Edit Restaurant Details
      </h2>

      <form
        onSubmit={
          updateRestaurant
        }
        style={styles.form}
      >

          <div style={styles.formGroup}>
            <label style={styles.label}>
              Restaurant Name
            </label>

        <input
          value={
            restaurantName
          }
          style={styles.input}
          onChange={(e) =>
            setRestaurantName(
              e.target.value
            )
          }
          required
        />
          </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>
            Address
          </label>

        <input
          value={
            restaurantAddress
          }
          style={styles.input}
          onChange={(e) =>
            setRestaurantAddress(
              e.target.value
            )
          }
        />
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>
            Phone
          </label>

        <input
          value={
            phone
          }
          style={styles.input}
          onChange={(e) =>
            setPhone(
              e.target.value
            )
          }
        />
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>
            Email
          </label>

        <input
          type="email"
          value={
            email
          }
          style={styles.input}
          onChange={(e) =>
            setEmail(
              e.target.value
            )
          }
        />
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>
            Upload Logo
          </label>

        <input
          type="file"
          style={styles.input}
          accept="image/*"
          onChange={(e) =>
            setLogo(
              e.target.files[0]
            )
          }
        />
        </div>

        <button
          disabled={loading}
          style={styles.saveBtn}
        >
          {loading
            ? "Updating..."
            : "Save Changes"}
        </button>

      </form>

      {/* QR SECTION */}

      {qrUrl && (

        <div style={styles.qrSection}>

          <h3>
            QR Code
          </h3>

          <img
            src={qrUrl}
            alt="QR"
            style={styles.qr}
          />

          <button
            onClick={
              downloadQR
            }
            style={styles.downloadBtn}
          >
            Download QR
          </button>

        </div>

      )}

      {/* LINK SECTION */}

      {menuUrl && (

        <div style={styles.linkSection}>

          <h3>
            Menu URL
          </h3>

          <input
            value={
              menuUrl
            }
            readOnly
            style={styles.linkInput}
          />

          <button
            onClick={
              copyLink
            }
            style={styles.copyBtn}
          >
            Copy Link
          </button>

        </div>

      )}

    </div>

  );

}
const styles = {
container: {
  padding: "20px",

  minHeight: "100vh",

  background: "#f5f6fa",

  fontFamily: "Segoe UI, sans-serif",

  width: "100%",

  boxSizing: "border-box"
},

  /* FORM */


form: {
  background: "#ffffff",

  maxWidth: "900px",

  margin: "0 auto 24px auto",

  padding: "24px",

  borderRadius: "16px",

  boxShadow:
    "0 8px 20px rgba(0,0,0,0.08)",

  display: "grid",

  gridTemplateColumns:
    "repeat(auto-fit, minmax(250px, 1fr))",

  gap: "16px"
},


  /* INPUT */



  /* SAVE BUTTON */

  saveBtn: {
    gridColumn: "1 / -1",

    padding: "14px",

    marginTop: "10px",

    background:
      "linear-gradient(90deg,#ff6a00,#ff8c00)",

    color: "#fff",

    border: "none",

    borderRadius: "12px",

    fontSize: "16px",

    fontWeight: "600",

    cursor: "pointer",

    boxShadow:
      "0 4px 12px rgba(255,106,0,0.4)"
  },

  formGroup: {
  display: "flex",
  flexDirection: "column",
  width: "100%"
},

input: {
  width: "100%",
  padding: "12px",

  borderRadius: "10px",

  border: "1px solid #ddd",

  fontSize: "14px",

  background: "#fafafa",

  outline: "none",

  boxSizing: "border-box"
},
label: {
  fontSize: "14px",
  fontWeight: "600",
  marginBottom: "6px",
  color: "#333"
},

  /* QR SECTION */

  qrSection: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "700px",

    background: "#ffffff",

    padding: "20px",

    borderRadius: "14px",

    boxShadow:
      "0 6px 14px rgba(0,0,0,0.08)",

    marginBottom: "20px",

    textAlign: "center"
  },

  qr: {

    maxWidth: "100%",

    margin: "10px ",

    borderRadius: "10px",

    border: "1px solid #eee"
  },

  downloadBtn: {
    background:
      "linear-gradient(90deg,#ff6a00,#ff8c00)",

    color: "#fff",

    border: "none",

    padding: "10px 16px",

    borderRadius: "10px",

    cursor: "pointer",

    fontWeight: "600"
  },

  /* LINK SECTION */

  linkSection: {
    maxWidth: "700px",

    background: "#ffffff",

    padding: "20px",

    borderRadius: "14px",

    boxShadow:
      "0 6px 14px rgba(0,0,0,0.08)",
    
    overflowX: "hidden",
  },

  linkInput: {
    width: "95%",

    padding: "12px",

    borderRadius: "10px",

    border: "1px solid #ddd",

    marginBottom: "12px",


    fontSize: "14px",

    background: "#fafafa"
  },

  copyBtn: {
    background:
      "linear-gradient(90deg,#ff6a00,#ff8c00)",

    color: "#fff",

    border: "none",

    padding: "10px 16px",

    borderRadius: "10px",

    cursor: "pointer",

    fontWeight: "600"
  }

};